// removed by extract-text-webpack-plugin
module.exports = {"general-setting-title":"index__general-setting-title___1-f2D","settings-taskOwner-content":"index__settings-taskOwner-content___EfFrL","taskOwner-content-description":"index__taskOwner-content-description___1-Uao","taskOwner-switch":"index__taskOwner-switch___3l2iE"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/GeneralSettings/index.less
// module id = 671
// module chunks = 3